import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";

export const getAllCreditCards = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'creditCards', {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

export const getAllCreditCardsObject = async () => {
    const allBrand = await getAllCreditCards();
    const allBrandObject = allBrand.map((brand , index) => {
        return {
            id : brand.id,
            value : brand.id,
            label : brand.category.persianName,
            parentId : null,
        }
    })
    return allBrandObject;
}

export const getCreditCardById = async (id) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + `creditCards/${id}` , {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            // console.log(response.data)
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

export const getCreditCardByPersonId = async (personId) => {
    const headers = getManagerHeader();
    return axios.get(baseCmsApiUrl + `creditCards?personId=${personId}` , {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            // console.log(response.data)
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getCreditCardObjectByPersonId = async (personId) => {
    const allCreditCard = await getCreditCardByPersonId(personId);
    const allCreditCardObject =[];
    for (let i = 0; i < allCreditCard.length; i++) {
        allCreditCardObject.push(
            {
                id : allCreditCard[i].id,
                value : allCreditCard[i].id,
                label : allCreditCard[i].name + " بانک: " + allCreditCard[i].bank + " ش.ک: " + allCreditCard[i].number+ " شبا: " + allCreditCard[i].shaba  ,
            }
        );
    }

    return allCreditCardObject;
}